var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","padless":"","dark":"","height":"30px"}},[_c('v-col',{staticClass:"text-center text-caption pa-0",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — WUD (version "+_vm._s(_vm.version)+") ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }